import React, { Fragment } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Redirect, Router } from '@reach/router';
import HomePage from './pages/HomePage';
import RoomPage from './pages/RoomPage';
import theme, { light } from './theme';
import { Navbar } from './components/navbar/Navbar';
import OffersPage from './pages/OffersPage';
import RestaurantPage from './pages/RestaurantPage';
import Footer from './components/Footer';
import { LanguageProvider } from './components/i18n/LanguageContext';

const ResetCss = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/ 
     v2.0 | 20110126
     License: none (public domain)
  */
  
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;

const GlobalCss = createGlobalStyle`
  html,
  body {
    width: 100vw;
    height: 100%;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    max-width: 100%;
    background: white;
  }
  
  body {
    font-family: 'Lora', serif;
    -webkit-font-smoothing: antialiased;
  }
  
  #root {
    background: black;
    width: 100%;
    max-width: 100%;
    height: 100%;   
  }
  
  * {
    box-sizing: border-box;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-weight: inherit;
  }
  
  a {
    text-decoration: none;
  }
  
  html {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
  }
  
  .active {
      position: relative;
      box-shadow: 0 -36px 46px 34px ${theme.colors.primary.toHex()};
   }  
`;

export const NotFound = () => <Redirect to={'/'} noThrow />;

const App = () => (
  <ThemeProvider theme={light}>
    <Fragment>
      <Navbar />
      <Router>
        <HomePage path="/" />
        <RoomPage path="/room/:id" />
        <RestaurantPage path="/restaurant/:id" />
        <OffersPage path="/promotions" />
        <NotFound path="/" />
      </Router>
      <Footer id={'footer'} />
      <ResetCss />
      <GlobalCss />
    </Fragment>
  </ThemeProvider>
);

export default LanguageProvider(App);
